.cta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 1.5rem;
  margin-top: 3rem;
}

.guide {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-weight: 500;
}
